import { useState } from 'react';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { regexConstants } from '../../../constants/regEx';
import { updateInternalRemarksApi } from '../apiService';
import { globalPutService } from '../../../utils/globalApiServices';
import { checkApiStatus } from '../../../utils';
import { trackActivity } from '../../../utils/mixpanel';

const InternalRemarks = ({ remarksEdit, onToggleModal, getResponseBack }) => {
    const { enqueueSnackbar } = useSnackbar();
    const [remarks, setRemarks] = useState(remarksEdit?.data?.internal_remarks || '');
    const [error, setError] = useState('');
    const [isLoading, setLoading] = useState(false);

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: 'Edit Internal Remarks', page_type: page_type, })
    }

    const onSaveRemarks = () => {
        setLoading(true);
        const payload = { slug: remarksEdit?.data?.slug, internal_remarks: remarks?.trim() };
        globalPutService(updateInternalRemarksApi(), payload)
            .then((response) => {
                setLoading(false);
                if (checkApiStatus(response)) {
                    getResponseBack();
                    onToggleModal();
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    trackActivity('Item Edited', { page_title: `Edit Internal Remarks`, success_msg: response?.data?.message, item_id: remarksEdit?.data?.id, payload: payload, response: response?.data })
                } else {
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    trackActivity('Item Edited', { page_title: `Edit Internal Remarks`, error_msg: response?.data?.message, item_id: remarksEdit?.data?.id, payload: payload, response: response?.data })
                }
            });
    };

    return (
        <Dialog aria-labelledby="edit-remarks-dialog-title" className='add-lease-dialog' maxWidth='md' fullWidth open={true}>
            <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header' id="edit-remarks-dialog-title">
                <Typography sx={{ marginLeft: '10px' }}> Edit Internal Remarks </Typography>
            </DialogTitle>
            <DialogContent dividers style={{ minWidth: '400px' }}>
                <TextField
                    id="internal_remarks"
                    label="Internal Remarks"
                    variant="outlined"
                    size="small"
                    margin="normal"
                    value={remarks}
                    onChange={(e) => { regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? setRemarks(e.target.value.trimStart()) : e.preventDefault() }}
                    slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 1000 } }}
                    fullWidth
                    multiline
                    rows={4}
                    error={Boolean(error)}
                    helperText={error || `${remarks?.length || 0}/1000`}
                    FormHelperTextProps={{ sx: { textAlign: error ? 'left' : 'right', ml: 0, mr: 0 } }}
                />
            </DialogContent>
            <DialogActions sx={{ paddingRight: '16px' }}>
                <Button className="cancel-btn" variant="outlined" size="small" disabled={isLoading} onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}> Cancel </Button>
                <Button variant="contained" size="small" className="btn-primary" disabled={isLoading} onClick={() => { onSaveRemarks(); handleItemClicked('Save Button') }}> {isLoading ? <CircularProgress color="inherit" size={20} /> : "SAVE"} </Button>
            </DialogActions>
        </Dialog>
    );
};

export default InternalRemarks;
